import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { UserdataService } from '../shared/userdata/userdata.service';

@Injectable({
  providedIn: 'root'
})
export class UpdateRequestServiceService {

  BaseUrl: string = ''  
  Token: any = '';
  
  constructor(
    private http: HttpClient, @Inject('BASE_URL') _base: string,
    private userdata: UserdataService
  ) {
    this.BaseUrl = _base
    this.Token = userdata.getData()
   }

  //------Charges Update Request
  public getChargeRequest(data: any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/showpricechangerequests", data, { headers: header_object});
  }

  public approveRejectChargeRequest(data:any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/approveorrejectprice", data, { headers: header_object});
  }

  public getSingleChargeRequest(data:any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/singlechargerequest", data, { headers: header_object});
  }
  //------Profile Update Request
  public getProfileRequest(data: any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/showopenupdaterequest", data, { headers: header_object});
  }

  public approveRejectProfileRequest(data: any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/approveorrejectprofile", data, { headers: header_object});
  }

  public singleProfileRequest(data:any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/singleopenupdaterequest", data, { headers: header_object});
  }

  public closeProfileRequest(data: any){
    var header_object = new HttpHeaders().set("Authorization", this.Token);
    return this.http.post(this.BaseUrl + "/closeprofilerequest", data, { headers: header_object});
  }

}
